<nz-spin [nzSpinning]="loading">
  <h3>
    Rēķini
    <label
      *hasPermission="[GroupPermission.MENU_BOOKKEEPER]"
      class="ml-4"
      nz-checkbox
      id="isAutomaticCalculationsEnabled"
      [(ngModel)]="isAutomaticCalculationsEnabled"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onIsAutomaticCalculationsEnabledChanged($event)"
      >
      Automātiskie aprēķini
    </label>
  </h3>
  <div class="w-full table-container">
    @if (sinvoice.invoices?.length > 0) {
      <nz-table
        #sinvoiceInvoices
        [nzData]="sinvoice.invoices"
        nzSize="small"
        [nzFrontPagination]="false"
        [nzScroll]="{ y: '15rem', x: '50rem' }"
        >
        <thead>
          <tr>
            <th>Pasūtījums</th>
            <th>Numurs</th>
            <th>Datums</th>
            <th>Bez PVN</th>
            <th>PVN</th>
            <th>Līgumsods</th>
            <th>Ar PVN</th>
            <th>Apmaksāts</th>
            <th>Neapmaksātā summa</th>
            <th>Darbības</th>
          </tr>
        </thead>
        <tbody>
          @for (invoice of sinvoiceInvoices.data; track invoice.id) {
            <tr>
              <td>{{ invoice.invoiceOrders ? invoice.invoiceOrders[0].number : '-' }}</td>
              <td>{{ invoice.number ? invoice.number : '-' }}</td>
              <td>{{ invoice.date ? (invoice.date | date : DATE_FORMAT) : '-' }}</td>
              <td>
                <nz-input-number
                  style="width: 100%"
                  [nzFormatter]="sumFormatter"
                  id="sumWithoutVat"
                  nzPlaceHolder="Bez PVN"
                  [(ngModel)]="invoice.sumWithoutVat"
                  (ngModelChange)="recalculateAllSums(invoice)"
                ></nz-input-number>
              </td>
              <td>
                <nz-input-group nzAddOnAfter="{{ invoice.vatPercent ?? 0 }}%">
                  <nz-input-number
                    style="width: 100%"
                    [nzFormatter]="sumFormatter"
                    id="sumVat"
                    nzPlaceHolder="PVN"
                    [(ngModel)]="invoice.sumVat"
                    (ngModelChange)="onSumVatChange(invoice)"
                  ></nz-input-number>
                </nz-input-group>
              </td>
              <td>
                <nz-input-number
                  style="width: 100%"
                  [nzFormatter]="sumFormatter"
                  id="penaltySumWithoutVat"
                  nzPlaceHolder="Līgumsods"
                  [(ngModel)]="invoice.penaltySumWithoutVat"
                  (ngModelChange)="recalculateAllSums(invoice)"
                ></nz-input-number>
              </td>
              <td>
                <nz-input-number
                  style="width: 100%"
                  [nzFormatter]="sumFormatter"
                  id="sumWithVat"
                  nzPlaceHolder="Ar PVN"
                  [(ngModel)]="invoice.sumWithVat"
                  (ngModelChange)="onSumWithVatChange(invoice)"
                ></nz-input-number>
              </td>
              <td><cl-true-false-table-icon [value]="invoice.isPaid"></cl-true-false-table-icon></td>
              <td>{{ invoice.unpaidSum | eur }}</td>
              <td>
                <nz-flex nzGap="small">
                  <button *hasPermission="[GroupPermission.INVOICE_VIEW]" nz-button nzType="info" (click)="openInvoice(invoice.id)">
                    <i nz-icon nzType="folder-open"></i>
                  </button>
                  @if (invoice.department) {
                    <ng-container
                      *hasDepartmentPermission="{ departmentId: invoice.department.id, permissions: [DepartmentPermission.EDIT] }"
                      >
                      <button
                        *hasPermission="[GroupPermission.SINVOICE_EDIT]"
                        nz-button
                        nzDanger
                        nz-tooltip
                        nzTooltipTitle="Atsaistīt"
                        (click)="removeInvoiceFromSinvoice(invoice.id)"
                        >
                        <i nz-icon nzType="delete"></i>
                      </button>
                    </ng-container>
                  } @else {
                    <button
                      *hasPermission="[GroupPermission.SINVOICE_EDIT]"
                      nz-button
                      nzDanger
                      nz-tooltip
                      nzTooltipTitle="Atsaistīt"
                      (click)="removeInvoiceFromSinvoice(invoice.id)"
                      >
                      <i nz-icon nzType="delete"></i>
                    </button>
                  }
                </nz-flex>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    } @else {
      <p class="m-0">Neviens apakšrēķins nav atrasts</p>
    }
    @if (!sinvoice.isDeleted) {
      @if (sinvoice.department) {
        <ng-container *hasDepartmentPermission="{ departmentId: sinvoice.department.id, permissions: [DepartmentPermission.EDIT] }">
          <div *hasPermission="[GroupPermission.SINVOICE_EDIT]" nz-row>
            <div nz-col [nzXXl]="6" [nzLg]="8" [nzMd]="12" [nzSm]="16" [nzXs]="24">
              <nz-flex nzGap="small" class="w-100">
                <cl-search-field
                  class="w-100"
                  fieldPlaceholder="Rēķins"
                  [modelType]="EntityType.Invoice"
                  [(object)]="toAddInvoice"
                  [allowClear]="true"
                  [customSearchFn]="searchInvoicesForSinvoice"
                ></cl-search-field>
                <button nz-button class="btn-success mb-2" (click)="addInvoiceToSinvoice()">Pievienot rēķinu</button>
              </nz-flex>
            </div>
          </div>
        </ng-container>
      } @else {
        <div *hasPermission="[GroupPermission.SINVOICE_EDIT]" nz-row>
          <div nz-col [nzXXl]="6" [nzLg]="8" [nzMd]="12" [nzSm]="16" [nzXs]="24">
            <nz-flex nzGap="small" class="w-100">
              <cl-search-field
                class="w-100"
                fieldPlaceholder="Rēķins"
                [modelType]="EntityType.Invoice"
                [(object)]="toAddInvoice"
                [allowClear]="true"
                [customSearchFn]="searchInvoicesForSinvoice"
              ></cl-search-field>
              <button nz-button class="btn-success mb-2" (click)="addInvoiceToSinvoice()">Pievienot rēķinu</button>
            </nz-flex>
          </div>
        </div>
      }
    }
  </div>
</nz-spin>
